import axios from 'axios'
import library from '../../../utils/Library'

export const getAllSuborganizationCustomerSupportCorpEntities = async (suborgId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('suborganizations') +
    '/getAllSuborganizationCustomerSupportCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: { firmSuborganizationId: suborgId }
  })
}
